export const tsl = {
    pecValidationMsg: 'Inserire un indirizzo pec valido',
    emailValidationMsg: 'Inserire un indirizzo e-mail valido',
    invalidEmailMatch: 'I due indirizzi pec non coincidono',
    fiscalCodeValidationMsg: 'Inserire un codice fiscale valido',
    generalValidationMsg: 'Verifica che i campi obbligatori siano stati correttamente inseriti o selezionati',
}

export const errorMessages = {
    GeneralError: "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
    GetContract: {
        "311": "Si è verificato un problema con il caricamento della promozione.",
        "300": "Si è verificato un problema con il caricamento della promozione.",
    },
    GetPromoData: {
        "201": "Link scaduto.",
        "301": "Link non valido.",
        "302": "Si è verificato un errore imprevisto.",
        "501": "Si è verificato un errore imprevisto.",
        "503": "Si è verificato un errore imprevisto.",
        "504": "Si è verificato un errore imprevisto.",
        "520": "TeamSystem ID non valido per il link utilizzato.",
        "521": "Link già utilizzato e non più valido."
    },
    SetLegalRepresentativeRole: {
        "301": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "302": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "303": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "304": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "501": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "502": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "503": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "504": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "505": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "507": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "508": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "520": "TeamSystem ID non valido per il link utilizzato.",
    },
    SetPromoData: {
        "301": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "302": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "501": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "503": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "509": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "510": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "512": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "520": "TeamSystem ID non valido per il link utilizzato.",
        "514": "Non è possibile inserire due e-mail identiche"
    },
    SendReminder: {
        "301": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "302": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "501": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "503": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "506": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "507": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "511": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "513": "Si è verificato un errore imprevisto. Se il problema persiste contatta MySupport.",
        "520": "TeamSystem ID non valido per il link utilizzato.",
    }
}
